<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>

        <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-row justify-content-between align-items-start">
                            <p class="text-muted mb-2">
                                <i class="fa fa-coins h2 text-primary align-middle mb-0 mr-3"></i> Twoje punkty
                            </p>
                            <span>
                                <i class="fa fa-question-circle" id="coins-info"></i>
                            </span>
                            <b-tooltip target="coins-info" placement="bottom" noninteractive>
                                Co zrobić, aby zdobyć punkty? Nic prostrzego! Musisz spędzać dużo czasu na naszym serwerze, a wtedy nasz system będzie Ci je dawał.
                            </b-tooltip>
                        </div>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3>{{ user.coins }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div v-for="item in data.items" :key="item.id" class="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-header text-center">
                        <h4><i :class="'fa ' + typeIcon[item.type]"></i> {{ item.name }}</h4>
                    </div>
                    <div class="card-body text-center">
                        <p v-html="item.description"></p>
                        <div class="d-flex justify-content-around align-items-center flex-row py-4">
                            <div>
                                <h3>{{ item.coins }}pkt</h3>
                                <span>Cena</span>
                            </div>
                            <div>
                                <h3>{{ item.duration }}</h3>
                                <span>Czas trwania <br><small>(w dniach)</small></span>
                            </div>
                        </div>

                        <h4>Co otrzymujesz?</h4>

                        <div v-if="item.type == 0">
                            <h5 class="mb-2" v-if="item.details.groups.length == 1">Super grupę</h5>
                            <h5 class="mb-2" v-else>Super grupy</h5>
                            <server-group v-if="item.details.groups.length == 1" class="justify-content-center" :group="item.details.groups[0]" withName/>
                            <server-groups v-else class="d-flex justify-content-center" :groups="item.details.groups" withName center/>
                        </div>

                        <b-tooltip v-if="item.coins > user.coins" :target="'product-' + item.id" placement="bottom" noninteractive>
                            Nie masz wystarczającej ilości punktów! Brakuje Ci jeszcze ich tyle: {{ item.coins - user.coins }}.
                        </b-tooltip>

                        <button
                            v-if="!item.has && item.coins <= user.coins"
                            class="btn btn-primary mt-5"
                            @click="buy(item.id)"
                        >
                            <i class="fa fa-shopping-cart"></i> Kup teraz
                        </button>
                        <button
                            v-else-if="!item.has && item.coins > user.coins"
                            :id="'product-' + item.id"
                            class="btn btn-danger mt-5"
                        >
                            <i class="fa fa-times"></i> Zbyt mało punktów
                        </button>
                        <div v-else class="mt-4">
                            <h3 class="text-success"><i class="fa fa-check"></i> Posiadasz już ten produkt</h3>
                            <small>Będziesz mógł go kupić znowu, kiedy minie jego czas.</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-chart-bar"></i> Historia Twoich zakupów
                    </div>
                    <div class="card-body">
                        <data-table
                            :items="data.history"
                            :fields="fieldsHistory"
                        >
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:type="row">
                                <span>{{ types[row.value] }}</span>
                            </template>
                            <template v-slot:details="row">
                                <div v-if="row.item.type == 0">
                                    Grupa/Grupy: <server-groups :groups="row.value.groups" withName/>
                                </div>
                            </template>
                            <template v-slot:active="row">
                                <span v-if="row.value" class="text-success"><i class="fa fa-check"></i> Aktywne</span>
                                <span v-else class="text-danger"><i class="fa fa-times"></i> Nieaktywne</span>
                            </template>
                        </data-table>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ShopService from "@/services/shop.service";
import Vue from "vue";
import {
    notificationMethods
} from "@/state/helpers";
import {
    hasGroup
} from "@/helpers/helper"

/**
 * Starter component
 */
export default {
    name: "Shop",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Sklep",
            items: [
                {
                    text: "Serwer",
                    href: "/"
                },
                {
                    text: "Sklep",
                    active: true
                }
            ],
            fieldsHistory: [
                {key: "active", label: "Status"},
                {key: "name", label: "Nazwa"},
                {key: "type", label: "Typ"},
                {key: "details", label: "Szczegóły"},
                {key: "coins", label: "Cena"},
                {key: "duration", label: "Czas trwania (dni)"},
                {key: "created_at", label: "Data kupna"},
            ],
            loading: true,
            data: {
                items: [],
                history: []
            },
            typeIcon: {
                0: 'fa-medal'
            },
            types: {
                0: "Grupa serwerowa"
            }
        };
    },
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ... notificationMethods,
        hasGroup: hasGroup,
        loadData() {
            this.loading = true;

            ShopService.getData().then(
                response => {
                    this.data = response.data;
                    this.filterItems();
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        filterItems() {
            this.data.items = this.data.items.filter(item => {
                if (item.ignored_server_groups && this.hasGroup(item.ignored_server_groups))
                    return false;
                else
                    return true;
            })
        },
        buy(id) {
            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Twoje konto punktów zostanie obciążone po tym jak klikniesz przycisk: 'Tak'",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, kup!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    ShopService.buy(id).then(
                        () => {
                            this.success("Przedmiot został pomyślnie zakupiony!");
                            this.loadData();
                        },
                        error => {
                            console.log(error);
                            this.loading = false;
                        }
                    )
                }
            });
        }
    }
};
</script>